import React from 'react';
import StaffCard from './StaffCard';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';

interface StaffMember {
  Name?: string;
  Area?: string;
  Reason?: string;
}

interface TopContributorsSectionProps {
  contributors: (StaffMember | string)[];
}

const TopContributorsSection: React.FC<TopContributorsSectionProps> = ({ contributors }) => {
  return (
    <div style={{
      background: '#fff',
      borderRadius: '12px',
      padding: '2rem',
      //marginBottom: '1.5rem',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      borderLeft: '4px solid #3182ce',
      breakInside: 'avoid'
    }}>
      <h2 style={{ color: '#3182ce', marginBottom: '1rem', fontSize: '1.5rem', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
        <EmojiEventsOutlinedIcon style={{ marginRight: '8px' }} />
        Top Contributors
      </h2>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {contributors?.map((staff, index) => (
          <StaffCard key={index} staff={staff} />
        ))}
      </ul>
    </div>
  );
};

export default TopContributorsSection;
